export const environment = {
  URL: 'https://psbu.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.simadvisory.com/auth',
  KEYCLOAK_REALM: 'SRT_Prod',
  KEYCLOAK_CLIENT_ID: 'P_SRT_Client',
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  COMPANY_LOGO_SRC: "assets/image.png",
  COMPANY_LOGO_TEXT: "PSBU Aftermarket Segmentation",
  SECONDARY_LOGO_SRC: "assets/secondary-logo.png",
  SECONDARY_COLOR: '#9ccafb',
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:8081',
   USE_ALT_SIDENAV: true,
  ALT_COMPANY_LOGO_SRC: 'assets/alt-image.png',
  ALT_SECONDARY_LOGO_SRC: 'assets/alt-secondary-image.png',
};
